import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=ecca1424&scoped=true"
import script from "./Team.vue?vue&type=script&lang=ts&setup=true"
export * from "./Team.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Team.vue?vue&type=style&index=0&id=ecca1424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecca1424",
  null
  
)

export default component.exports